export default "<p>vehicule works!</p>\n"